import { Component, OnInit, ViewChild } from '@angular/core'
import { FormSearchComponent } from '../../../shared/components/form-search/form-search.component'
import { MatProgressBar } from '@angular/material/progress-bar'
import { PaginationComponent } from '../../../shared/components/pagination/pagination.component'
import { TableListComponent } from '../../../shared/components/table-list/table-list.component'
import { AuthService } from '../../../core/services/auth/auth.service'
import { MatDialog } from '@angular/material/dialog'
import { ReactiveFormsModule } from '@angular/forms';
import {
  PagedContactTypeResponse,
  SearchContactTypeModel,
} from '../../../core/models/contact-type.model'
import { PatientEditComponent } from '../../../features/patient/patient-edit/patient-edit.component'
import { MonitoringService } from '../../../core/services/monitoring/legal-entity-client/monitoring.service'
import { MatPaginator } from '@angular/material/paginator'
import { FormClientSearchComponent } from '../../../shared/components/form-client-search/form-search.component'
import { responseDefaultForm } from '../../../shared/utils/utils'
import { MatPaginatorModule } from '@angular/material/paginator'
import { PageEvent } from '@angular/material/paginator'
import {SnackbarCustomService} from '../../../shared/components/snackbar/snackbar-custom.service';
import {MatCard} from '@angular/material/card';
import {MatFormField, MatLabel, MatOption, MatSelect} from '@angular/material/select';
import {FormBuilder, FormGroup, FormsModule, Validators} from '@angular/forms';
import {ResponseRequestModel} from '../../../core/models/response.model';
import {MunicipalityService} from '../../../core/services/municipality/municipality/municipality.service';
import {HealthUnitService} from '../../../core/services/health-unit/location/health-unit.service';

@Component({
  selector: 'patient-main',
  imports: [
    ReactiveFormsModule,
    FormSearchComponent,
    MatProgressBar,
    PaginationComponent,
    TableListComponent,
    FormClientSearchComponent,
    MatPaginatorModule,
    MatCard,
    MatSelect,
    MatOption,
    MatFormField,
    MatLabel,
    FormsModule,
  ],
  templateUrl: './patient-main.component.html',
  styleUrl: './patient-main.component.scss',
  standalone: true,
  providers: [MonitoringService],
})
export class PatientMainComponent implements OnInit {
  constructor(
    private legalEntityClientService: MonitoringService,
    private municipalityService: MunicipalityService,
    private healthUnitService: HealthUnitService,
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private dialog: MatDialog,
  ) {}

  page: number = 1
  rows: number = 10
  numberRows: number = 0
  itemsList: any[] = []
  isSelectHealthUnitActive: boolean = false
  municipiosList: any[] = []
  unidadeSaudeList: any[] = []
  municipioSelected: number | null = null
  unidadeSaudeSelected: number | null = null
  loading: boolean = false
  columns: any[] = [
    // { keyColumn: 'code', key: 'id', description: 'Código' },
    // {
    //   keyColumn: 'corporate_name',
    //   key: 'razaoSocial',
    //   description: 'Razão social',
    // },
    {
      keyColumn: 'name',
      key: 'nomeCompleto',
      description: 'Nome',
    },
    {
      keyColumn: 'cpf',
      key: 'cpf',
      description: 'CPF',
    },
    // {
    //   keyColumn: 'subCliente',
    //   key: 'subCliente',
    //   description: 'Email',
    // },
    {
      keyColumn: 'imc',
      key: 'imc',
      description: 'IMC',
    },
    {
      keyColumn: 'historico_clinico',
      key: 'historico_clinico',
      description: 'Histórico Clínico',
    },
    {
      keyColumn: 'UnidadeSaude',
      key: 'unidade_saude',
      description: 'Unidade de Saúde',
    },
    {
      keyColumn: 'action',
      key: { edit: false, delete: false },
      description: 'Ações',
    },
  ]

  listSearch: any = [
    { id: 'nome', description: 'Nome', type: 'string', visible: true },

    { id: 'cpf', description: 'CPF', type: 'string', visible: true },
    { id: 'unidade_id', description: 'Unidade de Sáude', type: 'number', visible: false },
    { id: 'municipio_id', description: 'Municipio', type: 'number', visible: false },
  ]

  inputSearch: any = { type: '', search: '' }
  searchForm: any = { search: false, model: {} }
  screen: string = 'paciente'

  showMunicipSelect = true
  showUnidadeSelect = true
  ngOnInit() {
    this.createForm()
    this.checkColumnAction()
    this.getMunicipio()
    if(this.authService.getProfile() === "3" || this.authService.getProfile() === "4"){
        this.municipioSelected = Number(this.authService.getMunicipio()||null)
        this.unidadeSaudeSelected = Number(this.authService.getUnidade()||null)
        this.showMunicipSelect = false
        this.showUnidadeSelect = false
      this.isSelectHealthUnitActive = true
      this.searchForm = {
        search: true,
        model: {
          ...this.searchForm.model,
          municipio_id: this.municipioSelected,
          unidade_id: this.unidadeSaudeSelected
        }
      };
    } else if(this.authService.getProfile() === "5"){
      this.municipioSelected = Number(this.authService.getMunicipio()||null)
      this.unidadeSaudeSelected = Number(this.authService.getUnidade()||null)
      this.getUnidadesDeSaude(this.municipioSelected!)
      this.isSelectHealthUnitActive = true
      this.form.get('unidadeSaude')?.enable()
      this.showMunicipSelect = false
      this.searchForm = {
        search: true,
        model: {
          ...this.searchForm.model,
          municipio_id: this.municipioSelected,
          unidade_id: null // Limpa unidade quando muda município
        }
      };
    }
    this.uploadList()
  }
  getUnidadesDeSaude(municipioId: number) {
    if (!municipioId) {
      this.unidadeSaudeList = [];
      return;
    }
    this.healthUnitService.listActiveLocationByMunicip(municipioId).subscribe({
      next: (response: ResponseRequestModel) => {
        this.unidadeSaudeList = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }
  getMunicipio(){
    this.municipalityService.listActiveMunicipality().subscribe({
      next: (response: any) => {
        if(response.data){
          this.municipiosList = response.data
        }
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
    })
  }
  checkColumnAction() {
    let index = this.columns.findIndex((ele: any) => {
      return ele.keyColumn == 'action'
    })
    if (index != -1) {
      this.columns[index].key = {
        edit: this.checkPermission('editar'),
      }
      if (!Object.values(this.columns[index].key).includes(true)) {
        this.columns.splice(index, 1)
      }
    }
  }

  checkPermission(permission: string) {
    return this.authService.checkPermission(permission, this.screen)
  }

  onMunicipioChange() {
    const municipioId = this.form.get('municipio')?.value;

    this.form.get('unidadeSaude')?.reset();

    if (municipioId) {
      this.isSelectHealthUnitActive = true;
      this.form.get('unidadeSaude')?.enable();
      this.getUnidadesDeSaude(municipioId);

      // Atualiza o searchForm mantendo outros filtros
      this.searchForm = {
        search: true,
        model: {
          ...this.searchForm.model,
          municipio_id: municipioId,
          unidade_id: null // Limpa unidade quando muda município
        }
      };

      this.page = 1;
      this.uploadList();
    } else {
      this.isSelectHealthUnitActive = false;
      this.form.get('unidadeSaude')?.disable();

      // Remove os filtros de município e unidade
      const { municipio_id, unidade_id, ...rest } = this.searchForm.model;
      this.searchForm = {
        search: Object.keys(rest).length > 0,
        model: rest
      };

      this.page = 1;
      this.uploadList();
    }
  }

  onUnidadeSaudeChange() {
    const unidadeId = this.form.get('unidadeSaude')?.value;

    if (unidadeId) {
      // Atualiza o searchForm mantendo outros filtros
      this.searchForm = {
        search: true,
        model: {
          ...this.searchForm.model,
          unidade_id: unidadeId
        }
      };

      this.page = 1;
      this.uploadList();
    } else {
      // Remove apenas o filtro de unidade
      const { unidade_id, ...rest } = this.searchForm.model;
      this.searchForm = {
        search: Object.keys(rest).length > 0,
        model: rest
      };

      this.page = 1;
      this.uploadList();
    }
  }

  uploadList(type: string = '') {
    if (type == 'new') {
      // Limpa TUDO
      if(this.authService.getProfile() === "1"){
        this.form.reset();
        this.isSelectHealthUnitActive = false;
      } else if(this.authService.getProfile() === "3" || this.authService.getProfile() === "4"){
        this.municipioSelected = Number(this.authService.getMunicipio()||null)
        this.unidadeSaudeSelected = Number(this.authService.getUnidade()||null)
        this.form.get('unidadeSaude')?.reset();
      this.unidadeSaudeSelected = null;
      } else if(this.authService.getProfile() === "5"){
        this.municipioSelected = Number(this.authService.getMunicipio()||null)
        this.unidadeSaudeSelected = Number(this.authService.getUnidade()||null)
      }
      this.searchForm = { search: false, model: {} };
    }

    this.getListItems();
  }
  // uploadList(type: string = '') {
  //   if (type == 'new') {
  //     // Limpa TUDO
  //     this.form.reset();
  //     this.unidadeSaudeSelected = null;
  //     this.municipioSelected = null;
  //     this.isSelectHealthUnitActive = false;
  //     this.searchForm = { search: false, model: {} };
  //   }
  //
  //   this.getListItems();
  // }
  form: FormGroup = new FormGroup({})

  createForm(): void {
    this.form = this.formBuilder.group({
      municipio: [null],
      unidadeSaude: [{ value: null, disabled: true }],
    })
  }
  search(event: any) {
    if (event.search) {
      const newModel = this.createModel(event.data);

      // IMPORTANTE: Preserva municipio_id e unidade_id dos selects
      const municipioId = this.searchForm.model?.municipio_id;
      const unidadeId = this.searchForm.model?.unidade_id;

      this.searchForm = {
        search: true,
        model: {
          ...newModel, // Novos filtros do form-search
          ...(municipioId && { municipio_id: municipioId }), // Preserva município
          ...(unidadeId && { unidade_id: unidadeId }) // Preserva unidade
        }
      };
    } else {
      // Limpa apenas os filtros do form-search, mantém município/unidade
      const municipioId = this.searchForm.model?.municipio_id;
      const unidadeId = this.searchForm.model?.unidade_id;

      this.searchForm = {
        search: !!(municipioId || unidadeId), // true se tiver município OU unidade
        model: {
          ...(municipioId && { municipio_id: municipioId }),
          ...(unidadeId && { unidade_id: unidadeId })
        }
      };
    }

    this.page = 1;
    this.uploadList(!event.search ? 'new' : '');
  }

  createModel(element: any) {
    let model: any = {}
    for (let i = 0; i < this.listSearch.length; i++) {
      const item = this.listSearch[i]
      model[item.id] =
        item.id == element.type
          ? element.search
          : responseDefaultForm(item.type)
    }
    return model
  }

  pageChanged(page: number) {
    this.page = page
    this.uploadList()
  }

  onPageEvent(event: PageEvent) {
    this.page = event.pageIndex + 1 // pageIndex é zero-based, a sua variável page é 1-based
    this.rows = event.pageSize
    this.uploadList()
  }

  pageSizeChanged(newPageSize: number) {
    this.rows = newPageSize
    this.page = 1 // normalmente reseta para a primeira página
    this.uploadList()
  }

  // uploadList(type: string = '') {
  //   if (type == 'new') {
  //     this.unidadeSaudeSelected = null
  //     this.municipioSelected = null
  //     this.searchForm = { search: false, model: {} }
  //   }
  //   if (this.searchForm.search) {
  //     this.getListItems()
  //   } else {
  //     this.getListItems()
  //   }
  // }

  treatResponse(response: any) {
    let list = []
    if (response.data) {
      for (let item of response.data) {
        list.push(item)
      }
    }
    this.itemsList = list
    this.numberRows = response.paging.total
  }

  // getListItems() {
  //   this.loading = true
  //   this.legalEntityClientService
  //     .listPagedLegalEntityClient(this.page, this.rows)
  //     .subscribe({
  //       next: (response: any) => {
  //         this.treatResponse(response)
  //       },
  //       error: (err: PagedContactTypeResponse) => {},
  //       complete: () => {
  //         this.loading = false
  //       },
  //     })
  // }
  getListItems() {
    this.loading = true
    console.log(this.searchForm.model)
    this.legalEntityClientService
      .listPagedAndSearchedName(this.page,this.rows,this.searchForm.model)
      .subscribe({
        next: (response: any) => {
          console.log('response',response)
          this.treatResponse(response)
        },
        error: (err: any) => {
          this.loading = false
        },
        complete: () => {
          this.loading = false
        },
      })
  }

  searchListItems() {
    this.loading = true
    this.legalEntityClientService
      .searchPagedLegalEntityClient(this.page, this.rows, this.searchForm.model)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: PagedContactTypeResponse) => {},
        complete: () => {
          this.loading = false
        },
      })
  }

  editItem(item: any) {
    const dialogRef = this.dialog.open(PatientEditComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
      data: { type: 'legal-entity-patient', item: item },
    })
    dialogRef.componentInstance.response.subscribe((response) => {
      if (response) {
        this.uploadList()
      }
    })
  }

  deleteItem(item: any) {
    console.log('item delete', item)
  }
}
